import React from "react";
import { useState, useEffect } from "react";
import {
  Navigate,
  Outlet,
  useLocation,
  useSearchParams,
} from "react-router-dom";

const ProtectedRoutes = () => {
  let location = useLocation();
  const [searchParams] = useSearchParams();

  return localStorage.jwtTokenSingh ? (
    <Outlet />
  ) : (
    <Navigate to={`/sign-in`} state={{ from: location }} />
  );
};

export default ProtectedRoutes;
